import axiosInstance from '../lib/axiosInstance';

export const getCountries = async () => {
  return axiosInstance.get('/countries');
};

export const updateAccount = async (payload, options = {}) => {
  const headers = {};

  if (options.jwt) headers.Authorization = `Bearer ${options.jwt}`;

  return axiosInstance.put('/account/update', payload, { headers });
};

export const requestPasswordReset = async (email) => axiosInstance.put('/account/request_password_reset', { email });

export const submitPasswordReset = async (payload) => axiosInstance.put('/account/password_reset', payload);